module.exports = __webpack_public_path__ + "img/soh.86524f94.svg";